module.exports = __webpack_public_path__ + "img/2.51efff49.jpg";